import { cx } from '@emotion/css';
import {
  CarouselV3 as CarouselV3SDS,
  Icon,
  MotifScheme,
} from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';
import { useContext } from 'react';

import { AppContext } from '../../../AppContext';
import type { CarouselV3CardItemProps } from '../../../components/CarouselV3';
import { CarouselV3ImageItem } from '../../../components/CarouselV3/CarouselV3ImageItem';
import { CarouselV3VideoItem } from '../../../components/CarouselV3/CarouselV3VideoItem';
import { type ContentfulIdVariable, useContentfulQuery } from '../../../hooks/useContentfulQuery';
import { type SnapHomePageV2Props, snapHomePageV2Query } from './SnapHomePageV2.query';
import {
  carouselAnimatedCss,
  carouselArrowIconCss,
  carouselOverrideStylesCss,
  carouselTitleCss,
  containerCss,
  preAnimationCss,
  titleAnimatedCss,
  titleCss,
} from './SnapHomePageV2.styles';

export const SnapHomePageV2: FC<{ id: string }> = props => {
  const { isRTL } = useContext(AppContext);
  const { data } = useContentfulQuery<SnapHomePageV2Props, ContentfulIdVariable>(
    snapHomePageV2Query,
    {
      variables: { id: props.id },
    }
  );

  const title = data?.snapHomePageV2?.title;
  const carouselTitle = data?.snapHomePageV2?.carouselTitle;
  const carouselCards = data?.snapHomePageV2?.carouselCardsCollection?.items;

  return (
    <div className={cx(MotifScheme.QUINARY, containerCss)}>
      <h1 className={cx(titleCss, data ? titleAnimatedCss : preAnimationCss)}>{title}</h1>
      {!!carouselCards?.length && (
        <div
          className={cx(carouselOverrideStylesCss, data ? carouselAnimatedCss : preAnimationCss)}
        >
          <div className={carouselTitleCss}>
            {carouselTitle}
            <Icon className={carouselArrowIconCss} name="chevron-down" size={28} />
          </div>
          <CarouselV3SDS
            isSingleView={false}
            autoPlay={false}
            isRtl={isRTL}
            enableOverflowDecoration={true}
            isResponsiveWidth={true}
          >
            {carouselCards.map(item => {
              const cardItem = item as CarouselV3CardItemProps;
              const hasVideo = cardItem?.media?.__typename === 'Video';

              return hasVideo ? (
                <CarouselV3VideoItem
                  key={cardItem.sys.id}
                  cardItem={cardItem}
                  mediaAspectRatio="16:9"
                  enableVideoControls={false}
                  isResponsiveWidth={true}
                  hideLinkArrow={true}
                />
              ) : (
                <CarouselV3ImageItem
                  key={cardItem.sys.id}
                  cardItem={cardItem}
                  mediaAspectRatio="16:9"
                  isResponsiveWidth={true}
                  hideLinkArrow={true}
                />
              );
            })}
          </CarouselV3SDS>
        </div>
      )}
    </div>
  );
};
